import { render, staticRenderFns } from "./HelpCard.vue?vue&type=template&id=77ef6b2c&scoped=true"
import script from "./HelpCard.vue?vue&type=script&lang=ts"
export * from "./HelpCard.vue?vue&type=script&lang=ts"
import style0 from "./HelpCard.vue?vue&type=style&index=0&id=77ef6b2c&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef6b2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ef6b2c')) {
      api.createRecord('77ef6b2c', component.options)
    } else {
      api.reload('77ef6b2c', component.options)
    }
    module.hot.accept("./HelpCard.vue?vue&type=template&id=77ef6b2c&scoped=true", function () {
      api.rerender('77ef6b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Help/Components/HelpCard.vue"
export default component.exports